// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { ROLE_LIST } from '../../config/API_Collection';
import { USER_ROLE_FAILURE, USER_ROLE_REQUEST, USER_ROLE_SUCCESS } from '../Actions/Actions';
import { getErrorMessage } from '../../config/Error_Codes';



function* fetchProjectsSaga() {
  try {
    const response = yield call(Axios.get,ROLE_LIST);
    console.warn(response);
    
    const projects = response.data.data || [];
    yield put({type:USER_ROLE_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:USER_ROLE_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* userRolesListSaga() {
  yield takeLatest(USER_ROLE_REQUEST, fetchProjectsSaga);
}
